var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 54,
    viewBox: "0 0 51 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0669 24.2228C19.1249 26.2478 13.0986 26.1322 7.12866 26.0745C8.24308 24.7437 17.6682 24.1361 23.0669 24.2228Z",
    fill: "#F7941D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.4326 36.2562C38.6623 36.9216 35.8629 35.533 32.8071 34.4052C28.6081 38.339 24.6091 47.4211 20.4107 48.2895C20.3818 42.4462 20.7538 36.1984 19.5253 31.6281C16.4117 26.8555 5.98703 29.7482 2.70232 25.1491C9.01463 23.7316 14.1555 21.0989 19.5253 18.6693C20.2107 13.521 18.811 11.1781 18.6398 8.48837C17.8114 -3.66129 18.4687 12.537 17.7544 18.6693C10.7566 19.0746 7.95727 23.8472 0.0452061 23.2974C0.0170493 33.2189 14.8127 27.6076 17.7544 34.4045C18.4968 43.5162 15.5552 47.5085 18.6398 53.8431C26.1518 51.5001 27.8086 43.0538 33.6926 39.0333C40.6614 38.5413 45.1746 40.5953 50.5156 41.8097C52.2576 34.2889 45.8312 27.6646 41.661 23.2974C45.2317 18.6982 47.8592 13.1165 49.6301 6.63669C44.6886 9.78952 36.0059 9.03743 31.0362 12.1903C28.4651 8.08306 24.323 0.70672 21.2962 0.156921C24.495 4.55383 27.7797 8.80551 30.1508 14.0412C34.0349 12.2184 42.3471 10.1363 46.089 11.2648C43.0325 14.8511 41.718 20.2898 39.0053 24.2228C42.4612 27.1156 47.4598 33.2478 46.9737 37.1824L43.4319 36.2562H43.4326ZM27.4944 20.521C24.5231 16.2396 24.0385 9.35531 21.2962 4.78501C22.724 10.1074 24.3238 20.0868 27.4944 20.521ZM28.3799 23.2974C33.2925 22.1118 40.6614 14.1279 40.7763 14.0412C35.8636 16.2974 31.8928 19.5659 28.3799 23.2974ZM23.0671 42.7352C24.123 39.5824 27.6648 30.0091 25.7235 29.7771C25.5805 34.26 21.6393 39.6402 23.0671 42.7352Z",
    fill: "url(#paint0_linear_271_1334)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.9747 37.1816C47.4593 33.2478 42.4615 27.1156 39.0048 24.2228C41.7183 20.289 43.0327 14.8511 46.0885 11.2648C42.3466 10.1363 34.0352 12.2192 30.1503 14.0412C27.7806 8.80551 24.4959 4.52493 21.2972 0.156921C24.3248 0.70672 28.466 8.08306 31.0372 12.1903C35.978 9.03743 44.6614 9.78952 49.6311 6.63669C47.8602 13.1157 45.2327 18.6982 41.6619 23.2974C45.8321 27.6654 52.2585 34.2889 50.5165 41.8097C45.1756 40.5946 40.6624 38.5413 33.6936 39.0333C27.8095 43.0538 26.1527 51.5001 18.6408 53.8431C15.5561 47.5078 18.4978 43.5162 17.7553 34.4052C14.8137 27.6076 0.0180259 33.2197 0.0461827 23.2981C7.95825 23.8472 10.7576 19.0746 17.7553 18.6693C18.4696 12.537 17.8124 -3.66129 18.6408 8.48837C18.812 11.1781 20.2116 13.521 19.5263 18.6693C14.1564 21.0997 9.04377 23.7316 2.7033 25.1491C5.95911 29.7482 16.4127 26.8555 19.5263 31.6281C20.7548 36.1984 20.3828 42.4462 20.4117 48.2895C24.61 47.4211 28.609 38.3383 32.8081 34.4052C35.8639 35.533 38.6632 36.9216 43.4336 36.2562",
    fill: "url(#paint1_linear_271_1334)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2964 4.78516C24.0098 9.32729 24.5241 16.2405 27.4946 20.5211C24.324 20.0869 22.7242 10.1075 21.2964 4.78516ZM40.7757 14.0413C40.6616 14.128 33.3216 22.112 28.3793 23.2975C31.893 19.566 35.8631 16.2976 40.7757 14.0413ZM25.7237 29.7773C27.6658 30.0085 24.1239 39.5825 23.0673 42.7354C21.6395 39.6403 25.5807 34.2602 25.7237 29.7773ZM32.7214 26.0747C31.3506 27.521 39.8621 32.6404 42.5755 34.3765C41.8612 31.0495 35.5489 29.4876 32.7214 26.0747Z",
    fill: "#F7941D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_271_1334",
    x1: 0.0634408,
    y1: 26.9893,
    x2: 50.8012,
    y2: 26.9893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBC2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4952,
    stopColor: "#FFC735"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD540"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_271_1334",
    x1: 21.5464,
    y1: -2.12045,
    x2: 33.0847,
    y2: 52.6295,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#F7912F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC709"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.491aed67f9e16729491104d6384f4949.svg";
export { ForwardRef as ReactComponent };